<template>
  <div
    :class="['x-single-date-picker-wrapper', { 'disabled': disabled }]"
    v-click-outside="close"
  >
    <div
      @click="toggleCalendar"
      :class="[{ 'remove-border-input': toggle, 'disabled': disabled, 'is-invalid': isInvalid }, 'date-input']"
    >
      <ic-calendar
        v-if="!hideIcon"
        class="date-picker-ic-calendar"
      />

      <input
        size="1"
        :class="{ 'disabled': disabled }"
        v-model="value"
        readonly
      />

      <span
        v-if="!hideIcon"
        :class="['date-picker-ic-dropdown', { 'dropdown-open': toggle, 'hide-dropdown': disabled }]"
      >
        <ic-dropdown />
      </span>
    </div>

    <div
      :class="[
        {'remove-border-date-picker': toggle},
        'x-date-picker',
        'x-single-date-picker'
      ]"
      v-if="toggle"
    >
      <flat-pickr
        v-model="value"
        :config="config"
        @on-change="changed"
        ref="datePickerWrap"
      >
      </flat-pickr>
    </div>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import { French } from 'flatpickr/dist/l10n/fr.js'
  import icCalendar from '@/svg/ic-calendar'
  import icDropdown from '@/svg/ic-dropdown'
  import vClickOutside from 'v-click-outside'

  export default {
    name: 'x-date-picker',

    props: {
      minDate: {
        type: String,
        default: null
      },
      maxDate: {
        type: String,
        default: null
      },
      value: {
        type: String,
        default: null
      },
      isInvalid: {
        type: Boolean,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      hideIcon: {
        type: Boolean,
        default: false
      }
    },

    components: {
      flatPickr,
      icCalendar,
      icDropdown
    },

    data () {
      return {
        toggle: false,
        config: {
          locale: French,
          inline: true,
          shorthandCurrentMonth: true,
          monthSelectorType: 'static',
          defaultDate: this.defaultDate,
          minDate: this.minDate,
          maxDate: this.maxDate
        }
      }
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    methods: {
      toggleCalendar () {
        if (!this.disabled) {
          this.toggle = !this.toggle
        }
      },

      changed (newDates, dateStr, instance) {
        this.toggle = false
        this.$emit('input', dateStr)
      },

      close () {
        this.toggle = false
      }
    },

    watch: {
      defaultDate (nVal) {
        this.$refs.datePickerWrap.fp.setDate(nVal)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import '~@/styles/datepicker.scss';

  .x-single-date-picker-wrapper {
    position: relative;

    &.disabled {
      background-color: $color-whisper;
    }

    .date-input {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 2rem;
      border: 2px solid #E5EAF5;
      box-sizing: border-box;
      border-radius: 4px;

      &.remove-border-input {
        border-radius: 4px 4px 0 0;
        border-bottom: none;
      }

      input {
        margin: 0 0.5rem;
        flex: 1;
        border: none;
        font-size: 1.6rem;
        font-weight: 600;
        font-family: "Source Sans Pro";

        &:focus {
          outline: none;
        }

        &.disabled {
          background-color: $color-whisper;
        }
      }
      .date-picker-ic-calendar {
        min-width: 1.2rem;
      }

      .date-picker-ic-dropdown {
        min-width: 2rem;
      }

      .dropdown-open {
        transform: rotateX(180deg);
      }

      .hide-dropdown {
        visibility: hidden;
      }

      &.is-invalid {
        border-color: $color-red !important;
      }
    }

    /deep/ .x-date-picker.x-single-date-picker .flatpickr-months .flatpickr-month .flatpickr-current-month .numInputWrapper{
      width: 4rem;
    }
  }
</style>
